import isEmpty from "lodash/isEmpty"

const validateTotalCount = (validate, type) => {
  const totalCount = []
  let count = 0
  if (validate[type] && type !== `planViolations` && !isEmpty(validate[type])) {
    validate[type].map(item => totalCount.push(item.violations.length))
    count = totalCount.reduce((acc, val) => {
      return acc + val
    })
  }
  return type !== `planViolations` ? count : validate[type].violations.length
}

export const categoryData = data => {
  const emptyData = isEmpty(data)
  return [
    {
      id: `event`,
      label: `В событиях`,
      data: emptyData ? [] : data.eventViolations,
      count: validateTotalCount(data, `eventViolations`),
    },
    {
      id: `resource`,
      label: `В ресурсах`,
      data: emptyData ? [] : data.resourceViolations,
      count: validateTotalCount(data, `resourceViolations`),
    },
    // TODO recommit in brightness future! or never
    // {
    //   id: `plan`,
    //   label: `В плане`,
    //   data: emptyData ? [] : data.planViolations,
    //   count: validateTotalCount(data, `planViolations`),
    // },
  ]
}
